module.exports = __webpack_public_path__ + "img/banner-tc4.40a1376c.jpg";